import type { Experience } from '../types';

type Priceable = Pick<Experience, 'price' | 'priceUnit' | 'currency'>;

function formatBRL(v: number, currency: string) {
  const code = currency === 'R$' ? 'BRL' : currency;
  try {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: code }).format(v);
  } catch {
    return `${currency} ${v.toFixed(2)}`;
  }
}

/** Regras de cobrança por priceUnit:
 *  - "por pessoa" (default): total = price × partySize
 *  - "por casal": total = price × ceil(partySize / 2)
 *  - "por grupo": total = price (fixo)
 */
function computeTotal(price: number, priceUnit: string, partySize: number): number {
  const unit = priceUnit?.toLowerCase() ?? '';
  if (unit.includes('grupo')) return price;
  if (unit.includes('casal')) return price * Math.ceil(partySize / 2);
  return price * partySize;
}

export function BookingTotal({ exp, partySize }: { exp: Priceable; partySize: number }) {
  if (!exp.price) return null;
  const total = computeTotal(exp.price, exp.priceUnit, partySize);
  const unit = exp.priceUnit || 'pessoa';

  return (
    <section className="total-box" aria-label="Valor total">
      <div className="total-box__row total-box__row--muted">
        <span>
          {formatBRL(exp.price, exp.currency)} / {unit}
        </span>
        <span>× {partySize}</span>
      </div>
      <div className="total-box__row total-box__row--total">
        <span>Total</span>
        <strong>{formatBRL(total, exp.currency)}</strong>
      </div>
    </section>
  );
}
